import { ArrowUp, Star, Facebook } from "lucide-react";
import { GOOGLE_REVIEWS_URL, FACEBOOK_URL } from "./Reviews";

export default function Footer({ scrollTo }) {
  return (
    <footer
      data-testid="site-footer"
      className="bg-zinc-950 text-white pt-16 lg:pt-24 pb-10 overflow-hidden"
    >
      <div className="px-4 sm:px-8 lg:px-12 max-w-7xl mx-auto">
        <div className="flex flex-wrap justify-between gap-10 pb-14 border-b border-zinc-800">
          <div className="max-w-sm">
            <div className="mb-4">
              <span className="inline-block bg-white px-3 py-2">
                <img
                  src="/logo.png"
                  alt="Xtra Clean Carpet Care and More logo"
                  className="h-10 w-auto"
                />
              </span>
            </div>
            <p className="text-zinc-400 text-sm leading-relaxed">
              Interior &amp; exterior painting, wood refinishing, and deep floor
              cleaning in San Angelo, TX. Fully insured. Over two decades of
              flawless finishes and free quotes.
            </p>
          </div>
          <nav className="flex flex-col gap-3">
            <p className="font-mono-x text-[10px] uppercase tracking-[0.25em] text-red-500 font-semibold mb-1">
              Explore
            </p>
            {[
              ["Services", "#services"],
              ["Heritage", "#heritage"],
              ["Gallery", "#gallery"],
              ["Reviews", "#reviews"],
              ["Free Quote", "#quote"],
              ["Contact", "#contact"],
            ].map(([label, href]) => (
              <button
                key={href}
                data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => scrollTo(href)}
                className="text-left text-zinc-400 hover:text-white transition-colors text-sm"
              >
                {label}
              </button>
            ))}
          </nav>
          <div className="flex flex-col gap-3">
            <p className="font-mono-x text-[10px] uppercase tracking-[0.25em] text-red-500 font-semibold mb-1">
              Reach Us
            </p>
            <a
              data-testid="footer-phone-link"
              href="tel:+13252345947"
              className="text-zinc-400 hover:text-white transition-colors text-sm"
            >
              325-234-5947
            </a>
            <a
              data-testid="footer-text-link"
              href="sms:+13252345947"
              className="text-zinc-400 hover:text-white transition-colors text-sm"
            >
              Text us: 325-234-5947
            </a>
            <a
              data-testid="footer-email-link"
              href="mailto:xtracleancarpet@gmail.com"
              className="text-zinc-400 hover:text-white transition-colors text-sm break-all"
            >
              xtracleancarpet@gmail.com
            </a>
            <p className="text-zinc-500 text-sm">Available 24/7 · Weekends included</p>
            <p className="text-zinc-500 text-sm">1311 S Chadbourne St, San Angelo, TX 76903</p>
            <div className="mt-2 flex items-center gap-3">
              <a
                data-testid="footer-google-link"
                href={GOOGLE_REVIEWS_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Xtra Clean on Google"
                className="flex items-center gap-1.5 text-zinc-400 hover:text-red-500 transition-colors text-xs font-mono-x uppercase tracking-wider"
              >
                <Star size={14} className="fill-current" /> Google
              </a>
              <a
                data-testid="footer-facebook-link"
                href={FACEBOOK_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Xtra Clean on Facebook"
                className="flex items-center gap-1.5 text-zinc-400 hover:text-red-500 transition-colors text-xs font-mono-x uppercase tracking-wider"
              >
                <Facebook size={14} /> Facebook
              </a>
            </div>
          </div>
        </div>

        <p
          data-testid="footer-brand-type"
          className="font-display font-black tracking-tight text-white/95 text-[11.5vw] leading-none whitespace-nowrap text-center py-10 select-none"
        >
          XTRA CLEAN<span className="text-red-600">&nbsp;&amp;&nbsp;</span>MORE
        </p>

        <div className="flex flex-wrap items-center justify-between gap-4 pt-6 border-t border-zinc-800">
          <p className="font-mono-x text-[10px] uppercase tracking-[0.2em] text-zinc-500">
            © {new Date().getFullYear()} Xtra Clean Carpet Clean &amp; More
          </p>
          <button
            data-testid="footer-back-to-top"
            onClick={() => scrollTo("#home")}
            className="flex items-center gap-2 font-mono-x text-[10px] uppercase tracking-[0.2em] text-zinc-400 hover:text-red-500 transition-colors"
          >
            Back to top <ArrowUp size={14} />
          </button>
        </div>
      </div>
    </footer>
  );
}
